import {z} from 'zod';

export const CampaignStatsCreatorSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  imageUrl: z.string().nullable().optional(),
  clickCount: z.number(),
  impressionCount: z.number(),
  postCount: z.number(),
});

export type CampaignStatsCreator = z.infer<typeof CampaignStatsCreatorSchema>;
